export default "__VITE_ASSET__CISyXgm7__"